import { useNavigate } from 'routes';
import { Button } from 'components/mui';
import { WestIcon } from 'components/icons';
import styles from './PermissionDenied.module.css';

/**
 * @component PermissionDenied
 * @returns {JSX.Element}
 */
function PermissionDenied() {
	const navigate = useNavigate();

	const onClick = () => {
		return navigate('/');
	};

	return (
		<section className={styles.main}>
			<section className={styles.section}>
				<h1>403 Forbidden - Permission Denied</h1>
				<hr className={styles.hr} />
				<p>
					The page you are trying to access has restricted access. Please refer to your system
					administrator.
				</p>
				<hr className={styles.hr} />
				<h3>Here is a button that you can go to the HOME page:</h3>
				<Button variant="outlined" startIcon={<WestIcon />} onClick={onClick}>
					GO BACK TO HOME
				</Button>
			</section>
		</section>
	);
}

export default PermissionDenied;
